export default __webpack_public_path__ + "static/media/NEAS0440.34I-35092_-20078_0.7a5c24d3.jpg";